// Import libraries
import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'
import { connect } from 'react-redux'

//Import site layouts 
import { LoginLayoutRoute } from './layouts/LoginLayout';
import { MainLayoutRoute } from './layouts/MainLayout';

//Import site routs 
import { RoutePath } from './constants/SitePaths';

// MainAFfilate
import Reports from './routes/mainAffilate/Reports';
import Affiliates from './routes/mainAffilate/Affiliates/Affiliates';
import Domains from './routes/mainAffilate/Domains';
import Withdraw from './routes/mainAffilate/Withdraw/Withdraw';
import Users from './routes/mainAffilate/Users/Users';
import SignUps from './routes/mainAffilate/SignUps';

// SubAffilate
import SubReports from './routes/subAffilate/SubReports';
import SubWithdraw from './routes/subAffilate/Withdraw/SubWithdraw';
import Players from './routes/subAffilate/Players';
import SubDomains from './routes/subAffilate/SubDomains';
import SubDesigns from './routes/subAffilate/SubDesigns';
import SubAccount from './routes/subAffilate/Account/Commissions';

//Account 
import Login from './routes/account/Login';
import Registration from './routes/account/Registration';
import SendVerificationCode from './routes/account/forgotPassword/SendVerificationCode';
import forgotPasswordChanging from "./routes/account/forgotPassword/RecoverPassword";
import RedirectPage from './routes/account/RedirectPage';

/**
 * Enum for Checking user type.
 * @readonly
 * @enum {number}
 */

export const userTypeEnum = {
  /** Users in Main Affiliate site */
  MainPartner: 1,
  /** Users in SubAffiliate site */
  SubPartner: 2
}

/** The main class of Affiliate, where discribed the routing of pages*/
class App extends React.Component {
  render() {
    const { currentUserType } = this.props.user;

    return (
      <Router>
        <Switch>
          <Route exact path={RoutePath.DEFAULT}>
            <Redirect to={RoutePath.LOGIN} />
          </Route>

          {/*Login Layout */}
          <LoginLayoutRoute path={RoutePath.LOGIN} component={Login} />
          <LoginLayoutRoute path={RoutePath.REGISTRATION} component={Registration} />
          <LoginLayoutRoute path={RoutePath.FORGOT_PASSWORD} component={SendVerificationCode} />
          <LoginLayoutRoute path={RoutePath.FORGOT_PASSWORD_CHANGING} component={forgotPasswordChanging} />

          {/*Main Layout */}
          <MainLayoutRoute exact path={RoutePath.AFFILIATES} component={Affiliates} />
          <MainLayoutRoute exact path={RoutePath.REPORTS} component={(parseInt(currentUserType, 10) === userTypeEnum.MainPartner ? Reports : SubReports)} />
          <MainLayoutRoute exact path={RoutePath.DOMAINS} component={parseInt(currentUserType, 10) === userTypeEnum.MainPartner ? Domains : SubDomains} />
          <MainLayoutRoute exact path={RoutePath.WITHDRAW} component={parseInt(currentUserType, 10) === userTypeEnum.MainPartner ? Withdraw : SubWithdraw} />
          <MainLayoutRoute exact path={RoutePath.USERS} component={Users} />
          <MainLayoutRoute exact path={RoutePath.SIGNUPS} component={SignUps} />
          <MainLayoutRoute exact path={`${RoutePath.PLAYERS}/:affiliateId?`} component={Players} />
          <MainLayoutRoute exact path={`${RoutePath.DESIGNS}/:affiliateId?`} component={SubDesigns} />
          <MainLayoutRoute exact path={RoutePath.Account} component={parseInt(currentUserType, 10) === userTypeEnum.SubPartner ? SubAccount : RedirectPage} />
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    affiliates: state.affiliates,
  }
}

export default connect(
  mapStateToProps,
  null
)(App);


// WEBPACK FOOTER //
// ./src/App.js